var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:{ [`uk-icon-${_vm.glyph}`]: true, [`uk-icon-${_vm.size}`]: true, 'uk-icon-spin': _vm.spin }})
}
var staticRenderFns = []

export { render, staticRenderFns }